import { Component, EventEmitter, inject, Input, OnInit, Optional, Output } from '@angular/core'
import { ControlContainer, NgForm, FormsModule } from '@angular/forms'

import { PrimeTemplate } from 'primeng/api'
import { AutoComplete } from 'primeng/autocomplete'
import { Supplier } from '@app/interfaces/supplier'
import { SuppliersApi } from '@app/apis/suppliers.api'
import { DetailMode } from '@app/components/generic/generic.constants'
import type { Supplier as SupplierListItem } from '@app/generated/api/model'

@Component({
  selector: 'app-supplier-field',
  templateUrl: 'supplier-field.component.html',
  styleUrl: 'supplier-field.component.less',
  viewProviders: [{
    provide: ControlContainer,
    deps: [[Optional, NgForm]],
    useFactory: (ngForm: NgForm) => ngForm,
  }],
  imports: [
    AutoComplete,
    FormsModule,
    PrimeTemplate,
  ],
})
export class SupplierFieldComponent implements OnInit {
  public readonly suppliersApi = inject(SuppliersApi)

  @Input() supplier?: Supplier
  @Input() required: boolean = false
  @Input() mode: string = 'normal'
  @Input() tabindex: number = -1

  @Output() supplierChange = new EventEmitter<Supplier | undefined>()

  public allSuppliers: SupplierListItem[] = []
  protected readonly DetailMode = DetailMode

  ngOnInit (): void {
    this.allSuppliers = []
  }

  /**
   * Return project codes matching the given code using an `icontains` matcher.
   * This is necessary because we cannot present a list of *all* projects: it must be pre-filtered.
  */
  getSupplierSuggestions ($event: { query: string, originalEvent: any }) {
    this.suppliersApi.list({ limit: 100, ordering: 'code', code: $event.query }).subscribe(
      res => {
        this.allSuppliers = res.results
      })
  }
}
